<app-company-entity-relationship-table
	[dataRequest]="dataRequest"
	style="flex: 1; display: flex; overflow: auto"
></app-company-entity-relationship-table>
